import { render, staticRenderFns } from "./SetupLayout.vue?vue&type=template&id=7adfd180&"
import script from "./SetupLayout.vue?vue&type=script&lang=js&"
export * from "./SetupLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports